import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { createHttpParams } from 'src/services/utilities';
import { ApiRequestParams } from 'src/models/global-interfaces';
import {
  rolesTableApiRequestParams,
  ProfileSummary,
  SingleProfileData,
  CreateRoleRequest,
  ProfileResource,
  CredResource,
} from 'src/models/role.model';
import { components } from 'be-types';

// TODO: Backend change needed here. Need to be consistent with the profileCredID param name
export interface RoleProfileCred {
  profileCredID: number;
  profileCredStatus: number;
}

export interface RoleCreateProfileCred {
  credID: number;
  profileCredStatus: number;
}

export type UpdateRoleRequest = components['schemas']['UpdateProfileRequest'] & {
  locationID?: number;
};

@Injectable({ providedIn: 'root' })
export class RoleService {
  private readonly http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  getRoles = (params: ApiRequestParams = rolesTableApiRequestParams, locationID?: number) => {
    if (locationID) params.locationID = locationID;
    return this.http.get<ProfileResource[]>(`${this.apiUrl}profiles`, {
      params: createHttpParams(params),
    });
  };

  getRoleById = (profileId: number, locationID?: number) =>
    this.http.get<SingleProfileData>(
      `${this.apiUrl}profiles/${profileId}`,
      locationID ? { params: { locationID } } : {},
    );

  createRole = (params: CreateRoleRequest) => this.http.post(`${this.apiUrl}profiles`, params);

  updateRole = (profileId: number, payload: UpdateRoleRequest) =>
    this.http.put<unknown>(`${this.apiUrl}profiles/${profileId}`, payload).pipe();

  deleteRole = (profileID: number) => {
    return this.http.delete<unknown>(`${this.apiUrl}profiles/${profileID}`);
  };

  deleteLocalRole = (profileID: number) =>
    this.http.delete<unknown>(`${this.apiUrl}securities/${profileID}`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  assignRoleAndLocations = (payload: any) =>
    this.http.post<unknown>(`${this.apiUrl}securities`, payload);

  unassignRole = (securityID: number) =>
    this.http.delete<unknown>(`${this.apiUrl}securities/${securityID}`).pipe();

  // TODO: We could probably do the same thing with default credentials that we are doing with
  // timezones, since this record set will not change often.
  getCreds = () => this.http.get<CredResource[]>(`${this.apiUrl}creds`);

  getTableRoles = (params: ApiRequestParams = rolesTableApiRequestParams) =>
    this.http.get<ProfileSummary[]>(`${this.apiUrl}profiles`, {
      params: createHttpParams(params),
    });
}
